<template>
  <div>
    <v-row>
      <v-col cols class="text-start">
        <span class="text-h6 font-weight-medium textLight--text text-start">
          {{ $t("organization.organizationProfile.courseDetails") }}
        </span>
      </v-col>

      <v-col cols="auto">
        <CreateOrUpdateTrainingValiditiesDialog :organization="organization" />
      </v-col>
    </v-row>

    <v-data-table
      disable-pagination
      disable-sort
      disable-filtering
      hide-default-footer
      hide-default-header
      :headers="headers"
      :server-items-length="totalCount"
      :items="items"
      :mobile-breakpoint="0"
      class="custom-data-table transparent"
    >
      <template #header="{ props: { headers } }">
        <tr class="card primary--text">
          <td
            v-for="header in headers"
            :key="header.value"
            :style="{ width: header.width, textAlign: header.align }"
          >
            {{ header.text }}
          </td>
        </tr>
      </template>

      <template #item="{ item, headers }">
        <tr class="card">
          <td
            :style="{
              textAlign: headers[0].align,
            }"
          >
            {{ item.training ? getLocalisedValue(item.training.title) : "-" }}
          </td>

          <td
            :style="{
              textAlign: headers[1].align,
            }"
          >
            {{ item.training ? item.training.certificateValidity : "-" }}
          </td>

          <td
            :style="{
              textAlign: headers[2].align,
            }"
          >
            {{
              item.certificateValidity != null ? item.certificateValidity : "-"
            }}
          </td>

          <td
            :style="{
              textAlign: headers[3].align,
            }"
          >
            <div class="d-flex justify-space-between">
              <v-icon color="error" @click="deleteTrainingValidity(item)">
                mdi-trash-can-outline
              </v-icon>
            </div>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <span class="subtitle-2 text-center font-weight-regular">
          {{ $t("noItems") }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { deleteTrainingValidity } from "@/app/organization-module/methods/createOrUpdateOrDeleteTrainingValidiy";
import CreateOrUpdateTrainingValiditiesDialog from "@/app/organization-module/components/organization-profile/CreateOrUpdateTrainingValiditiesDialog";

export default {
  name: "OrganizationCourseValidity",
  components: { CreateOrUpdateTrainingValiditiesDialog },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("organization.organizationProfile.courseName"),
          value: "training",
          align: "start",
        },
        {
          text: this.$t("organization.organizationProfile.existingValidity"),
          value: "existingValidity",
          width: "250px",
          align: "center",
        },
        {
          text: this.$t("organization.organizationProfile.newValidity"),
          value: "newValidity",
          width: "250px",
          align: "center",
        },
        {
          text: "",
          value: "actions",
          width: "64px",
        },
      ];
    },
    items() {
      return this.organization?.trainingValidities ?? [];
    },
    totalCount() {
      return this.items?.length ?? [];
    },
  },
  methods: {
    deleteTrainingValidity(item) {
      this.$dialog
        .confirm(this.$t("organization.organizationProfile.confirmDelete"), {
          loader: true,
        })
        .then(dialog => {
          deleteTrainingValidity(item).then(res => {
            if (res.error) this.$toast.error("Some error occurred!");
            dialog?.close();
          });
        })
        .catch(_ => {});
    },
  },
};
</script>

<style lang="scss" scoped></style>
